import { CartState } from "./interfaces";

const cartInitialState: CartState = {
  items: [],
  payPalPaymentInProcess: false,
};

export { cartInitialState };
